import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row, Statistic, Tag } from "antd";
import { useTranslation } from "react-i18next";
import ResponsiveTable from "../../../design-system/ResponsiveTable";
import { formatEuro } from "../workReports/format";
import { STATE_COLORS, stateLabels } from "./labels";

/** Contract value of a main offer: original, approved and open Nachträge, current value. */
const ContractOverview = ({ overview, currentId, lng, title }) => {
  const { t } = useTranslation("dashboard");
  const states = stateLabels(t);
  if (!overview) return null;
  return (
    <Card className="mb-3 co-overview" title={title || t("Contract overview")}>
      <Row gutter={[16, 16]} className="mb-3">
        <Col xs={12} md={6}>
          <Statistic title={t("Original order")} value={formatEuro(overview.originalNet, lng)} />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title={t("Approved change orders")}
            value={formatEuro(overview.approvedNet, lng)}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title={`${t("Open change orders")} (${overview.pendingCount})`}
            value={formatEuro(overview.pendingNet, lng)}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title={t("Current contract value")}
            value={formatEuro(overview.currentNet, lng)}
          />
        </Col>
      </Row>
      {overview.changeOrders?.length > 0 && (
        <ResponsiveTable
          mobileAvatar={false}
          size="small"
          rowKey="_id"
          pagination={false}
          dataSource={overview.changeOrders}
          rowClassName={row => (String(row._id) === String(currentId) ? "co-current-row" : "")}
          columns={[
            {
              title: t("Change order"),
              key: "number",
              mobile: "title",
              render: (_, row) => (
                <Link to={`/user/change-orders/${row._id}`}>
                  {row.number} {row.title}
                </Link>
              )
            },
            {
              title: t("Status"),
              key: "state",
              mobile: "badge",
              width: 170,
              render: (_, row) => <Tag color={STATE_COLORS[row.state]}>{states[row.state]}</Tag>
            },
            {
              title: t("Net"),
              key: "net",
              width: 120,
              align: "right",
              render: (_, row) => formatEuro(row.net, lng)
            }
          ]}
          scroll={{ x: 480 }}
        />
      )}
      <div className="co-small">
        {t("Net amounts. Rejected and withdrawn change orders do not count.")}
      </div>
    </Card>
  );
};

export default ContractOverview;
